import React from 'react';

const Image = ({ alt, ...restProps }) => {
  const altValue = alt ? alt : '';
  return <img alt={altValue} {...restProps} />;
};

export default Image;
